import { render, staticRenderFns } from "./user-login.vue?vue&type=template&id=bd0c1b62&scoped=true&"
import script from "./user-login.vue?vue&type=script&lang=js&"
export * from "./user-login.vue?vue&type=script&lang=js&"
import style0 from "./user-login.vue?vue&type=style&index=0&id=bd0c1b62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0c1b62",
  null
  
)

export default component.exports